import { Component, Input, OnInit } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"
import { Observable } from "rxjs"
import { PreviewService } from "../../../services/preview.service"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-resource-browse-card",
    templateUrl: "./resource-browse-card.component.html",
    styleUrls: ["./resource-browse-card.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class ResourceBrowseCardComponent extends CardComponent implements OnInit {
    @Input() public type: string = "standard" //  standard/medium/large
    @Input() public listenToResize: boolean = false
    @Input() public gtmDataCardNumber: number

    public static standardPosterImageWidth: number = 260
    public static standardPosterImageHeight: number = 165

    isInPreviewMode: boolean = false

    constructor(
        public userService: UserService,
        private previewService: PreviewService
    ) {
        super(userService)
    }

    ngOnInit() {
        this.isInPreviewMode =
            this.previewService.previewOnCollection || this.previewService.previewOnSubCollection
    }

    public isLargeCard() {
        return this.type === "large"
    }

    public isMediumCard() {
        return this.type === "medium"
    }

    public isStandardCard() {
        return this.type === "standard"
    }

    /**
     * get the image size for standard, medium and large cards [width, height]
     */
    public getPosterImageSize() {
        if (this.isLargeCard()) {
            return [413, 233]
        }

        if (this.isMediumCard()) {
            return [282, 159]
        }

        return [
            ResourceBrowseCardComponent.standardPosterImageWidth,
            ResourceBrowseCardComponent.standardPosterImageHeight,
        ]
    }

    public getPosterImageWidth() {
        return this.getPosterImageSize()[0]
    }

    public getPosterImageHeight() {
        return this.getPosterImageSize()[1]
    }

    public getMediaType() {
        if (this.learningObject.mediaType && this.learningObject.mediaType.length) {
            return this.learningObject.mediaType[0]
        }
        return ""
    }

    public truncateSize() {
        let titleLength = this.learningObject.title.length
        let descLength

        if (this.isStandardCard()) {
            if (titleLength >= 77) {
                titleLength = 77
                descLength = 150
            } else {
                descLength = 130
            }
            return descLength - titleLength
        }

        if (this.isLargeCard()) {
            descLength = 150
            if (titleLength >= 167) {
                return 0
            }
            return descLength - titleLength
        }
        return 0
    }

    public titleHeight() {
        if (this.isLargeCard()) {
            return this.learningObject.title.length >= 115 ? 64 : 0
        }
        return this.learningObject.title.length > 60 ? 64 : 0
    }
}
